export default __webpack_public_path__ + "static/media/ASSET_01@2x.b083eaac.png";